import { useEffect } from 'react';
import moment from 'moment/moment';
import { LOGOUT } from 'utilities/routes';
import StorageService from 'utilities/storageService';
import { LAST_REQUEST } from '../firebase/constants';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/context/AuthContext';

const TIME_INTERVAL_LOGOUT = 20;
const lastRequestTime = new StorageService(LAST_REQUEST);

export const useAutoLogout = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const time = lastRequestTime.getData();

    if (
      user?.uuid &&
      moment().subtract(TIME_INTERVAL_LOGOUT, 'minutes').isAfter(moment(time))
    ) {
      navigate(LOGOUT);
    }
  }, [navigate, user]);
};
